// LogoutButton.jsx
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { performLogout } from '../slices/authSlice';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const LogoutButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleLogout = async () => {
        // Demander confirmation avant la déconnexion
        if (!window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
            return;
        }

        setIsLoading(true);
        
        try {
            // Simuler un petit délai pour l'UX
            await new Promise(resolve => setTimeout(resolve, 500));
            
            // Appeler l'action de déconnexion qui nettoie tout
            dispatch(performLogout());
            
            // Nettoyer les données de session
            sessionStorage.clear();
            
            // Rediriger vers la page d'accueil
            navigate('/', { replace: true });
            
            // Forcer un rechargement pour s'assurer que tout est bien nettoyé
            window.location.reload();
        } catch (error) {
            console.error('Erreur lors de la déconnexion:', error);
            setIsLoading(false);
        }
    };

    return (
        <button
            onClick={handleLogout}
            disabled={isLoading}
            className={`${isLoading ? 'bg-gray-400 cursor-not-allowed' : 'btn-danger'} flex items-center space-x-2`}
            title="Se déconnecter de votre compte"
        >
            {isLoading ? (
                <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Déconnexion...</span>
                </>
            ) : (
                <>
                    <ArrowRightOnRectangleIcon className="w-4 h-4" />
                    <span>Déconnexion</span>
                </>
            )}
        </button>
    );
};

export default LogoutButton;
